import axios from '../utils/axios';

// 🏢 Get Personal Website by Url
export const getByUrl = async (req) => {
    const response = await axios.get('/api/PersonalWebsite/GetByUrl', {
        params: {
            url: req.url
        }
    });
    return response.data;
};
